import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ait-auth-form',
  templateUrl: './auth-form.component.html',
  styleUrls: ['./auth-form.component.scss']
})
export class AitAuthFormComponent implements OnInit {
  @Input() isAuthenticating: boolean;
  @Input() loginTitle = 'Login';
  @Output() login: EventEmitter<any> = new EventEmitter<any>();

  loginForm: FormGroup;
  constructor(private fb: FormBuilder) {}

  onLoginClick() {
    if (this.loginForm.valid) {
      this.login.emit(this.loginForm.value);
    }
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: [null, [Validators.required, Validators.maxLength(180)]],
      password: [null, [Validators.required, Validators.maxLength(255)]]
    });
  }
}
